<div class="sftp-requests-container">
  <app-table
    [columns]="columns"
    [data]="requestsData"
    [scrollHeight]="'400px'"
    [loading]="loading"
    [pagination]="pagination"
    [emptyMessage]="emptyMessage"
    [striped]="true"
    [bordered]="true"
    [hoverable]="true"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  >
    <!-- Custom Asset Status Column (green/red dotted circle) -->
    <ng-template #assetStatusCell let-row>
      <div class="asset-status-cell">
        <span
          class="asset-status-indicator"
          [ngClass]="getAssetStatusIndicatorClass(row.assetStatus)"
          [attr.aria-label]="row.assetStatus"
        ></span>
        <span class="asset-status-label">{{ row.assetStatus }}</span>
      </div>
    </ng-template>

    <!-- Custom Request Status Column -->
    <ng-template #requestStatusCell let-row>
      <div [ngClass]="getRequestStatusChipClass(row.requestStatus)">
        {{ row.requestStatus }}
      </div>
    </ng-template>

    <!-- Custom Permission Column (chips like datasets page) -->
    <ng-template #permissionCell let-row>
      <div [ngClass]="getPermissionBadgeClass(row.permission)">
        <img
          *ngIf="row.permission && row.permission.toUpperCase() === 'RESTRICTED'"
          src="/icons/lock-blue.svg"
          alt="Restricted"
          class="permission-badge-icon"
        />
        <img
          *ngIf="row.permission && (row.permission.toUpperCase() === 'OPEN' || row.permission.toUpperCase() === 'PUBLIC')"
          src="/icons/globe-blue.svg"
          alt="Public"
          class="permission-badge-icon"
        />
        <img
          *ngIf="row.permission && row.permission.toUpperCase() === 'PRIVATE'"
          src="/filters/lock.svg"
          alt="Private"
          class="permission-badge-icon"
        />
        <span>{{ getPermissionLabel(row.permission) }}</span>
      </div>
    </ng-template>

    <!-- Custom Action Column -->
    <ng-template #actionCell let-row>
      <div class="action-cell-wrapper">
        <button 
          class="action-btn" 
          appActionDropdownTrigger
          (click)="toggleActionDropdown($event, row)"
          [class.active]="isDropdownOpen(row)"
          type="button"
        >
          <span>Action</span>
        </button>
        
        <!-- Dropdown Menu -->
        <div 
          class="action-dropdown-menu" 
          *ngIf="isDropdownOpen(row)" 
          [attr.data-dropdown-id]="getRowId(row)"
          (click)="$event.stopPropagation()"
        >
          <ul class="dropdown-list">
            <li class="dropdown-item">
              <button class="dropdown-link" (click)="handleAction('view', row)">
                View
              </button>
            </li>
            <li class="dropdown-item">
              <button
                class="dropdown-link"
                [disabled]="row.requestStatus?.toLowerCase() === 'granted'"
                [class.dropdown-link--disabled]="row.requestStatus?.toLowerCase() === 'granted'"
                (click)="row.requestStatus?.toLowerCase() === 'granted' ? null : handleAction('approve', row)"
              >
                Approve
              </button>
            </li>
            <li class="dropdown-item">
              <button
                class="dropdown-link"
                [disabled]="row.requestStatus?.toLowerCase() === 'granted'"
                [class.dropdown-link--disabled]="row.requestStatus?.toLowerCase() === 'granted'"
                (click)="row.requestStatus?.toLowerCase() === 'granted' ? null : handleAction('reject', row)"
              >
                Reject
              </button>
            </li>
          </ul>
        </div>
      </div>
    </ng-template>
  </app-table>
</div>

<!-- View SFTP Request Modal -->
<app-modal
  [(visible)]="isViewModalOpen"
  header="SFTP Upload Details"
  [width]="'800px'"
  [showFooter]="false"
  (onClose)="closeViewModal()"
>
  <div class="sftp-view-modal-content">
    <div class="sftp-view-modal--leaf-pattern">
      <img src="/assets-leaf.png" alt="" class="sftp-view-modal--leaf-image" />
    </div>
    <app-sftp-upload [form]="viewSftpForm" [readonly]="true" [showValidation]="false"></app-sftp-upload>
  </div>
</app-modal>
